import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Ideas from "./pages/Ideas";
import About from "./pages/About";
import RegisterPage from "./pages/RegisterPage";
import ThankYouPage from "./pages/ThankYouPage";
import RefCodeForm from "./pages/RefCodeForm";
import NotFoundPage from "./pages/404";
import Navbar from "./components/Navbar";

function App() {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/ideas" element={<Ideas />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/generate-referral-code"
          element={<RefCodeForm />}
        />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/register/:referralParam" element={<RegisterPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/404" element={<NotFoundPage />} />
        {/* Catch-all route for undefined paths */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
